import { createContext, useContext, useState } from "react";

const Context = createContext({
  mobileNumber: "",
  setMobileNumber: (mobileNumber: string) => {}
});

export function ContextHookProvider({ children }: any) {
  const [mobileNumber, setMobileNumber] = useState("");

  return (
    <Context.Provider
      value={{
        mobileNumber,
        setMobileNumber
      }}
    >
      {children}
    </Context.Provider>
  );
}

const useContextHook = () => useContext(Context);

export default useContextHook;
